import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Spinner } from 'react-mdl'

import ImageThumbnail from '../components/ImageThumbnail'
import Button from '../components/Button'

const TableContainer = styled.div`
  margin-top: 10px;
  max-height: 660px;
  overflow-y: auto;
`

const Table = styled.table`
  width: 100%;
  border: 1px solid black;
  border-right: 0px;
  border-spacing: 0;
  thead tr {
    background-color: #cccccc;
    height: 25px;
    line-height: 25px;
  }
  tbody tr:nth-child(odd) {
    background-color: #eeeeee;
  }
  tbody td {
    padding: 0.25em;
  }
  tr td,
  tr th {
    border-right: 1px solid black;
    width: 100px;
    text-align: center;
  }
  tr td:first-child,
  tr th:first-child {
    width: 5%;
  }
  tr td:nth-child(2),
  tr th:nth-child(2) {
    width: 25%;
    text-align: left;
  }
  tr td:nth-child(3),
  tr th:nth-child(3) {
    width: 60%;
    text-align: left;
  }
  tr td:last-child,
  tr th:last-child {
    width: 10%;
  }
  td {
    border-right: 1px solid black;
  }
`

const ImageTable = ({
  searchingLibrary,
  loading,
  images,
  selectedImages,
  onImageSelected,
}) => {
  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <th>Check</th>
            <th>File</th>
            <th>Tags</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {!searchingLibrary && !loading ? (
            images.map(image => (
              <tr key={image._id}>
                <td>
                  <input
                    value={image._id}
                    type="checkbox"
                    onChange={onImageSelected}
                    checked={selectedImages.includes(image._id)}
                  />
                </td>
                <td>
                  <div>
                    <ImageThumbnail
                      imageId={image._id}
                      style={{ width: 100 }}
                    />
                    <p>{image.description}</p>
                  </div>
                  <div>
                    <Link to={`/assetlibrary/edit/${image._id}/`}>
                      <Button raised primary>
                        Edit
                      </Button>
                    </Link>
                  </div>
                </td>
                <td>{image.tags.join(', ')}</td>
                <td>{image.contentType ? image.contentType : 'N/A'}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td>
                <Spinner />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </TableContainer>
  )
}

export default ImageTable



// WEBPACK FOOTER //
// ./src/AssetLibrary/ImageTable.js